<template>
    <div style="display: flex; justify-content: center; background-color: white;  ">
        <div style="display: flex; flex-direction: column; align-items: center;">
            <div style="max-height: 50px; margin: 20px" class="animate">
                <img :src="swayLogo" style="max-width: 100%; max-height: 30px">
            </div>
            <div class="header animate">
                <div>
                    Update to Version 6.0!
                </div>

                <div style="height: 2px; width: 100%; background-color: #34d3fd">
                    
                </div>
            </div>
            <div style="margin-top: 10px">
                <p>
                    Version 6.0 is available for download! Please update the app by visiting either the Apple Store or Google Play Store.
                </p>
                
                
            </div>
        </div>

    </div>
</template>

<script>
import swayLogo from '@/assets/images/sway-logo.png'

export default {
    name: "PleaseUpdate600",
    components: {},
    data() {
        return {
            swayLogo,
        }
    }
}
</script>

<style scoped>

</style>